var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.883 4.87432L6.46453 11.4645C4.51191 13.4171 4.51184 16.5829 6.46447 18.5355C8.41709 20.4881 11.5829 20.4881 13.5355 18.5355L13.5364 18.5347L19.7937 12.292C20.1847 11.902 20.8179 11.9027 21.2079 12.2937C21.598 12.6847 21.5973 13.3178 21.2063 13.7079L14.9497 19.9497C14.9496 19.9499 14.9499 19.9496 14.9497 19.9497C12.216 22.6829 7.78377 22.6832 5.05025 19.9497C2.3182 17.2177 2.31658 12.7891 5.0454 10.0551L11.4644 3.46437C13.417 1.51175 16.5829 1.51181 18.5355 3.46444C20.4865 5.41542 20.4882 8.57758 18.5404 10.5306L12.1214 17.1214C10.9498 18.2929 9.05025 18.2929 7.87868 17.1213C6.70711 15.9497 6.70711 14.0502 7.87868 12.8786L14.4645 6.29286C14.855 5.90234 15.4882 5.90234 15.8787 6.29286C16.2692 6.68339 16.2692 7.31655 15.8787 7.70708L9.29289 14.2929C8.90237 14.6834 8.90237 15.3166 9.29289 15.7071C9.68212 16.0963 10.3124 16.0976 10.7032 15.7109L17.1213 9.12123C18.2928 7.94966 18.2929 6.05022 17.1213 4.87865C15.9512 3.70852 14.0549 3.70708 12.883 4.87432Z",
    fill: "currentColor"
  })));
}

export default SvgAttach;